import { combineReducers } from 'redux';

import state from './state/reducer';
import chatMessages from './chatMessages/reducer';
import chatItems from './chatItems/reducer';
import activeState from './activeState/reducer';
import chatQuestionnaires from './chatQuestionnaires/reducer';
import chatQuestions from './chatQuestions/reducer';
import feedbackSubmission from './feedbackSubmission/reducer';
import chatDocuments from './chatDocuments/reducer';
import chatWebsites from './chatWebsites/reducer';
import chatScheduledSessions from './chatScheduledSessions/reducer';
import chatWritingIndicator from './chatWritingIndicator/reducer';
import queueRejection from './queueRejection/reducer';
import chatResources from './chatResources/reducer';
import paging from './paging/reducer';
import textEditing from './textEditing/reducer';
import emojis from './emojis/reducer';

export default combineReducers({
  state,
  chatMessages,
  chatQuestionnaires,
  chatQuestions,
  chatItems,
  activeState,
  feedbackSubmission,
  chatDocuments,
  chatWebsites,
  chatScheduledSessions,
  chatWritingIndicator,
  queueRejection,
  chatResources,
  paging,
  textEditing,
  emojis
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/reducer.js
 **/